<h4 mat-dialog-title class="mb-0 d-flex justify-content-between align-items-center">
  <span i18n="@@newRole.Title">{{ viewType === ViewType.UPDATE ? 'Update' : 'Create' }} Role</span>
  <button mat-icon-button (click)="closeDialog()">
    <mat-icon>close</mat-icon>
  </button>
</h4>

<div mat-dialog-content>
  <div class="mb-2 mt-3">
    <div class="row">
      <mat-vertical-stepper class="w-100" [linear]="true" #stepper>
        <ng-template matStepperIcon="edit">
          <mat-icon>check</mat-icon>
        </ng-template>
        <mat-step [completed]="false" *ngIf="isCreatingNew">
          <ng-template matStepLabel i18n="@@newRole.NewRole">New Role</ng-template>
          <app-role-name [roleType]="$any(roleType)" [parentNamespace]="parentNamespace"
            (proceed)="proceedSettingIssuer($event)" (cancel)="confirmClose($event.touched)"></app-role-name>
        </mat-step>
        <mat-step [completed]="false">
          <ng-template matStepLabel i18n="@@newRole.SetRoleIssuers">Set Role Issuers</ng-template>
          <div *ngIf="!isCreatingNew"
            class="card card-result d-flex flex-row justify-content-start align-items-center shadow-none d-flex pt-3 pb-2 mb-3 mr-3 mt-2">
            <span class="pb-2">{{ namespace }}</span>
          </div>
          <app-set-role-type-dids-or-name roleType="Issuer" [typeDefinition]="issuer" [signerDID]="signerDID"
            (next)="proceedSettingRevokers($event)" [showBackButton]="isCreatingNew" [showCancelButton]="!isCreatingNew"
            (cancel)="closeDialog()" (back)="back()"></app-set-role-type-dids-or-name>
        </mat-step>
        <mat-step [completed]="false">
          <ng-template matStepLabel i18n="@@newRole.SetRoleRevokers">Set Role Revokers</ng-template>
          <app-set-role-type-dids-or-name roleType="Revoker" [typeDefinition]="revoker" [signerDID]="signerDID"
            (next)="proceedSettingRestrictions($event)" [showBackButton]="isCreatingNew"
            [showCancelButton]="!isCreatingNew" (cancel)="closeDialog()"
            (back)="back()"></app-set-role-type-dids-or-name>
        </mat-step>
        <mat-step [completed]="false">
          <ng-template matStepLabel i18n="@@newRole.SetRestrictions">Set Restrictions</ng-template>
          <div class="card card-default d-flex shadow-none d-flex pt-3 mb-3">
            <div class="label default-color ml-1 pb-2" i18n="@@newRole.RoleRecondition">Role Precondition</div>
            <app-card-info description="Users must possess the roles as set in this Role Precondition section before they can enrol to this
                role."></app-card-info>
            <div class="card-result mb-1" *ngIf="!roleForm?.value?.data?.enrolmentPreconditions[0]?.conditions?.length">
              <div class="d-flex justify-content-between flex-row flex-nowrap">
                <div class="default-color break-word" i18n="@@newRole.NoRolePrecondition">No role precondition set</div>
              </div>
            </div>
            <div class="card-result mb-1" *ngFor="
                let rolePrecondition of roleForm?.value?.data?.enrolmentPreconditions[0]?.conditions;
                let i = index
              ">
              <div class="d-flex justify-content-between flex-row flex-nowrap">
                <div class="default-color break-word">{{ rolePrecondition }}</div>
                <div class="d-inline-flex">
                  <button mat-icon-button matSuffix class="mat-primary icon-btn-small color-error" matTooltip="Remove"
                    (click)="removePreconditionRole(i)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-lg-12">
                <app-smart-search [placeholderSearch]="'Search Role Namespace (Optional)'"
                  [searchText]="restrictionRoleControl" [searchType]="SmartSearchEnum.Add"
                  (add)="addRestriction($event)"></app-smart-search>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-end mb-2">
            <button mat-stroked-button class="btn btn-small mr-2" (click)="back()">Back</button>
            <button mat-raised-button class="btn btn-small btn-primary" data-qa-id="next-restrictions"
              [disabled]="isChecking" (click)="goNextStep()" i18n="@@newRole.Btn.Next">
              Next
            </button>
          </div>
        </mat-step>
        <mat-step [completed]="false">
          <ng-template matStepLabel i18n="@@newRole.SetValidityPeriod">Set Validity Period</ng-template>
          <app-validity-period [validityPeriod]="validityPeriod" (back)="back()"
            (next)="addValidityPeriod($event)"></app-validity-period>
        </mat-step>

        <mat-step [completed]="false">
          <ng-template matStepLabel i18n="@@newRole.SetRequestorFields">Set Requestor Fields</ng-template>
          <app-role-field [fieldsList]="requestorFields.data"
            (updateData)="requestorFieldsChangeHandler($event)"></app-role-field>
          <div class="d-flex justify-content-end mb-2">
            <button mat-stroked-button class="btn btn-small mr-2 back" data-qa-id="back" (click)="back()"
              i18n="@@newRole.Btn.Back">Back</button>
            <button mat-raised-button class="btn btn-small btn-primary" [disabled]="isChecking"
              data-qa-id="next-requestor-fields" (click)="goNextStep()" i18n="@@newRole.Btn.Next">
              Next
            </button>
          </div>
        </mat-step>

        <mat-step [completed]="false">
          <ng-template matStepLabel i18n="@@newRole.SetIssuerFields">Set Issuer Fields</ng-template>
          <app-role-field [fieldsList]="issuerFields.data"
            (updateData)="issuerFieldsChangeHandler($event)"></app-role-field>
          <div class="d-flex justify-content-end mb-2">
            <button mat-stroked-button class="btn btn-small mr-2 back" data-qa-id="back" (click)="back()"
              i18n="@@newRole.Btn.Back">Back</button>
            <button mat-raised-button class="btn btn-small btn-primary" data-qa-id="next-issuer-fields"
              [disabled]="isChecking" (click)="goNextStep()" i18n="@@newRole.Btn.Next">
              Next
            </button>
          </div>
        </mat-step>

        <mat-step [editable]="false" [completed]="false">
          <ng-template matStepLabel i18n="@@newRole.ConfirmDetails">Confirm Details</ng-template>
          <div class="card card-default d-flex shadow-none d-flex pt-3 mb-3">
            <div class="text-left my-3">
              <div class="label opacity-50 mb-2" i18n="@@newRole.RoleType">Role Type</div>
              <span class="default-color mb-0">
                {{ roleForm?.value?.roleType | domainType }}
              </span>
            </div>
            <mat-divider></mat-divider>
            <div class="text-left my-3">
              <div class="label opacity-50 mb-2" i18n="@@newRole.RoleNamespace">Role Namespace</div>
              <span class="default-color mb-0">
                {{ roleForm?.value?.roleName }}
              </span>
            </div>
            <mat-divider></mat-divider>
            <div class="text-left my-3">
              <div class="label opacity-50 mb-2" i18n="@@newRole.IssuerType">Issuer Type</div>
              <span class="default-color mb-0">
                <!-- {{ roleForm?.value?.data?.issuer?.issuerType }} -->
              </span>
            </div>
            <mat-divider></mat-divider>
            <div class="text-left my-3" *ngIf="isIssuerDIDType">
              <div class="label opacity-50 mb-2" i18n="@@newRole.IssuerList">Issuer List</div>
              <div class="default-color mb-0" *ngFor="let did of issuer?.did">
                {{ did }}
              </div>
            </div>
            <div class="text-left my-3" *ngIf="isIssuerRoleType">
              <div class="label opacity-50 mb-2" i18n="@@newRole.IssuerRoleNamespace">Issuer Role Namespace</div>
              <span class="default-color mb-0">
                {{ issuer.roleName }}
              </span>
            </div>
            <mat-divider></mat-divider>
            <div class="text-left my-3" *ngIf="isRevokerDIDType">
              <div class="label opacity-50 mb-2" i18n="@@newRole.RevokerList">Revoker List</div>
              <div class="default-color mb-0" *ngFor="let did of revoker?.did">
                {{ did }}
              </div>
            </div>
            <div class="text-left my-3" *ngIf="isRevokerRoleType">
              <div class="label opacity-50 mb-2" i18n="@@newRole.RevokerRoleNamespace">Revoker Role Namespace</div>
              <span class="default-color mb-0">
                {{ revoker.roleName }}
              </span>
            </div>
            <mat-divider></mat-divider>
            <div class="text-left my-3">
              <div class="label opacity-50 mb-2" i18n="@@newRole.ValidityPeriodType">Validity period Type</div>
              <span class="default-color mb-0">
                {{ validityPeriod | timeDuration }}
              </span>
            </div>
            <mat-divider></mat-divider>
            <div class="text-left my-3">
              <div class="label opacity-50 mb-2" i18n="@@newRole.RestrictionsRolePreconditions">Restrictions (Role
                Preconditions)</div>
              <div class="default-color mb-0"
                *ngIf="!roleForm?.value?.data?.enrolmentPreconditions[0]?.conditions?.length" i18n="@@newRole.None">
                None
              </div>
              <div class="default-color mb-0"
                *ngFor="let precondition of roleForm?.value?.data?.enrolmentPreconditions[0]?.conditions">
                {{ precondition }}
              </div>
            </div>
            <mat-divider></mat-divider>
            <div class="text-left mt-3">
              <div class="label opacity-50 mb-2" i18n="@@newRole.RequestFields">Requestor Fields</div>
              <span class="default-color mb-0" *ngIf="!requestorFields?.data?.length" i18n="@@newRole.None"> None
              </span>

              <ng-container *ngIf="requestorFields.data.length">
                <div class="field-list">
                  <app-fields-summary *ngFor="let element of requestorFields.data" [element]="element"
                    class="field-list-item mt-3 mb-2 px-2 pb-3 pt-4 d-block"></app-fields-summary>
                </div>
              </ng-container>
            </div>
            <mat-divider></mat-divider>
            <div class="text-left mt-3">
              <div class="label opacity-50 mb-2" i18n="@@newRole.IssuerRequiredFields">Issuer Required Fields</div>
              <span class="default-color mb-0" *ngIf="!issuerFields?.data?.length" i18n="@@newRole.None"> None </span>

              <ng-container *ngIf="issuerFields.data.length">
                <div class="field-list">
                  <app-fields-summary *ngFor="let element of issuerFields.data" [element]="element"
                    class="field-list-item mt-3 mb-2 px-2 pb-3 pt-4 d-block"></app-fields-summary>
                </div>
              </ng-container>
            </div>
          </div>
          <div>
            <div class="d-flex justify-content-end mb-2">
              <button mat-stroked-button class="btn btn-small mr-2" (click)="back()"
                i18n="@@newRole.Btn.Back">Back</button>
              <button mat-raised-button class="btn btn-small btn-primary" data-qa-id="confirm-details"
                (click)="confirmRole()" i18n="@@newRole.Btn.Next">
                Next
              </button>
            </div>
          </div>
        </mat-step>
        <ng-container *ngFor="let step of txs; let i = index">
          <mat-step [editable]="false" [completed]="false">
            <ng-template matStepLabel>{{ step.info }}</ng-template>
            <app-card-info [description]="step.info"></app-card-info>
            <div
              class="card card-hint d-flex flex-row justify-content-start align-items-center shadow-none d-flex pt-3 pb-2 mb-3">
              <mat-icon>notifications_none</mat-icon>
              <span class="pb-2" i18n="@@newRole.ConfirmTxMessage"> Please confirm this transaction in your connected
                Wallet. </span>
            </div>
            <div class="d-flex justify-content-end mb-3">
              <button mat-stroked-button class="btn btn-small mr-2" (click)="closeDialog()"
                i18n="@@newRole.Btn.Cancel">Cancel</button>
              <button mat-raised-button class="btn btn-small btn-primary" (appRetryBtn)="retry()"
                i18n="@@newRole.Btn.Retry">Retry</button>
            </div>
          </mat-step>
        </ng-container>
        <mat-step [completed]="false">
          <ng-template matStepLabel i18n="@@newRole.Complete">Complete</ng-template>
          <app-transactions-complete *ngIf="isCompleted" (completed)="closeDialog(true)"></app-transactions-complete>
        </mat-step>
      </mat-vertical-stepper>
    </div>
  </div>
</div>